import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './TrackerDetail.module.scss';

const ReferralProvidersList = ({ referrals, direction, candidateStatus, currentUserId }) => {
  const { t } = useTranslation('common');

  if (!referrals || referrals.length === 0) return null;

  return (
    <div className={styles.providersCard}>
      <h4 className={styles.providersTitle}>
        {direction === 'my'
          ? t('tracker.referralProviders', 'Referral Providers')
          : t('tracker.referredCandidates', 'Referred Candidates')}
      </h4>

      {referrals.map((referral, idx) => {
        const avatar = referral.avatar_thumb;
        const name = referral.full_name || referral.short_name || referral.email || t('tracker.unknown', 'Unknown');
        const initials = name
          .split(' ')
          .map((n) => n[0])
          .join('')
          .substring(0, 2)
          .toUpperCase();

        const isSelected = referral.showSelected || referral.id === currentUserId;

        return (
          <div key={`${referral.id || referral.uuid}-${idx}`} className={styles.providerItem}>
            {avatar ? (
              <img src={avatar} alt="" className={styles.providerAvatar} />
            ) : (
              <div className={styles.providerAvatarPlaceholder}>{initials}</div>
            )}

            <div className={styles.providerInfo}>
              <span className={styles.providerName}>{name}</span>
              {referral.email && <span className={styles.providerMeta}>{referral.email}</span>}
            </div>

            {isSelected && direction === 'my' && (
              <span className={styles.selectedBadge}>
                {t('tracker.primaryReferralProvider', 'Primary Referral Provider')}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ReferralProvidersList;
